import './marketing.css'
import MarketingShell from '../layouts/MarketingShell'
import { mountSurface } from '../lib/inertia'

// Marketing is light-theme only (no initTheme / no dark mode) — a deliberate
// product decision reflected in the mockups.
// Only top-level files are Inertia pages; shared chrome lives in
// pages/marketing/shell + i18n and is imported directly, not resolved as a page.
mountSurface({
  pages: import.meta.glob('../pages/marketing/*.tsx'),
  layout: (page) => <MarketingShell>{page}</MarketingShell>,
})
